import { InformationDisplayComponent } from './information-display.component';

export default angular
  .module('sfMobile.components.information-display', ['sfMobile.templates'])
  .component('sfInformationDisplay', InformationDisplayComponent).name;
